import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLang, CONTACT } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();
  return (
    <footer className="bg-bone border-t border-bone-200 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <img src="/logo.gif" alt="AEMBAIX — Associació d'Esclerosi Múltiple del Baix Llobregat" className="h-24 w-auto object-contain mb-4" />
            <p className="text-pine-700 leading-relaxed max-w-xs">{f.tagline}</p>
          </div>
          <div className="space-y-3">
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-pine-700 hover:text-terracotta transition-colors">
              <Phone className="w-4 h-4" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-pine-700 hover:text-terracotta transition-colors break-all">
              <Mail className="w-4 h-4" /> {CONTACT.email}
            </a>
            <p className="flex items-center gap-3 text-pine-700">
              <MapPin className="w-4 h-4" /> {f.location}
            </p>
          </div>
          <div className="md:text-right">
            <p className="text-sm text-pine-700">© {year} AEMBAIX.</p>
            <p className="text-sm text-pine-700">{f.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
